import React from "react";
import { Check, Minus, Plus } from "lucide-react";

const base = "rounded-xl border-2 text-left transition-colors";
const on = "border-[#3b9dff] bg-[#eef4ff]";
const off = "border-slate-200 hover:border-[#3b9dff]/50 bg-white";

export const Q = ({ title, hint, children, testid }) => (
  <div className="mt-8 first:mt-0" data-testid={testid}>
    <p className="font-bold text-[#0a1f44]">{title}</p>
    {hint && <p className="text-xs text-slate-500 mt-0.5">{hint}</p>}
    <div className="mt-3">{children}</div>
  </div>
);

export const Single = ({ options, value, onChange, testid, cols = "sm:grid-cols-2" }) => (
  <div className={`grid ${cols} gap-2`}>
    {options.map((o, i) => (
      <button key={o} type="button" onClick={() => onChange(o)} data-testid={`${testid}-${i}`}
        className={`${base} px-4 py-3 text-sm font-semibold text-[#0a1f44] ${value === o ? on : off}`}>{o}</button>
    ))}
  </div>
);

export const Multi = ({ options, value = [], onChange, testid, cols = "sm:grid-cols-2" }) => (
  <div className={`grid ${cols} gap-2`}>
    {options.map((o, i) => {
      const active = value.includes(o);
      return (
        <button key={o} type="button" data-testid={`${testid}-${i}`} onClick={() => onChange(active ? value.filter((x) => x !== o) : [...value, o])}
          className={`${base} flex items-center gap-3 px-4 py-3 text-sm font-semibold text-[#0a1f44] ${active ? on : off}`}>
          <span className={`w-5 h-5 shrink-0 rounded border flex items-center justify-center ${active ? "bg-[#3b9dff] border-[#3b9dff]" : "border-slate-300"}`}>{active && <Check className="w-3.5 h-3.5 text-white" />}</span>
          {o}
        </button>
      );
    })}
  </div>
);

export const Counter = ({ value, onChange, min = 0, max = 20, testid }) => (
  <div className="inline-flex items-center gap-3" data-testid={testid}>
    <button type="button" onClick={() => onChange(Math.max(min, value - 1))} data-testid={`${testid}-minus`} className="w-10 h-10 rounded-full border-2 border-slate-200 flex items-center justify-center hover:border-[#3b9dff]"><Minus className="w-4 h-4" /></button>
    <span className="w-8 text-center text-xl font-extrabold text-[#0a1f44]" data-testid={`${testid}-value`}>{value}</span>
    <button type="button" onClick={() => onChange(Math.min(max, value + 1))} data-testid={`${testid}-plus`} className="w-10 h-10 rounded-full border-2 border-slate-200 flex items-center justify-center hover:border-[#3b9dff]"><Plus className="w-4 h-4" /></button>
  </div>
);

export const Text = (props) => (
  <input {...props} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#3b9dff] focus:outline-none text-sm" />
);
